/**
 * Vendor portal — split-bundle entry App.
 */
import { VENDOR_PORTAL_MODULES } from "@/shared/config/platform-config";
import { Routes, Route, Navigate } from "react-router-dom";
import { PortalAppShell } from "@/shared/app/PortalAppShell";
import SafeRoute from "@/components/system/SafeRoute";
import { ProtectedVendorRoute, VendorLayout } from "@/apps/vendor";
import { portalPath } from "@/shared/app/portalPath";
import {
  VendorLogin, VendorDashboard, VendorArrivals, VendorDepartures,
  VendorDailyRental, VendorTours, VendorStays, VendorInterpreters, VendorChanges,
} from "@/apps/vendor/routes";

const S = ({ name, children }: { name: string; children: React.ReactNode }) => (
  <SafeRoute name={name}>{children}</SafeRoute>
);

const VendorApp = () => {
  const p = portalPath("vendor");
  const protectedLayout = (
    <ProtectedVendorRoute><VendorLayout /></ProtectedVendorRoute>
  );
  const childRoutes = (
    <>
      <Route index element={<S name="VendorDashboard"><VendorDashboard /></S>} />
      <Route path="dashboard" element={<S name="VendorDashboard"><VendorDashboard /></S>} />
      <Route path="arrivals" element={<S name="VendorArrivals"><VendorArrivals /></S>} />
      <Route path="departures" element={<S name="VendorDepartures"><VendorDepartures /></S>} />
      <Route path="daily" element={<S name="VendorDaily"><VendorDailyRental /></S>} />
      <Route path="tours" element={VENDOR_PORTAL_MODULES.tours ? <S name="VendorTours"><VendorTours /></S> : <Navigate to="../arrivals" replace />} />
      <Route path="stays" element={VENDOR_PORTAL_MODULES.stays ? <S name="VendorStays"><VendorStays /></S> : <Navigate to="../arrivals" replace />} />
      <Route path="interpreters" element={VENDOR_PORTAL_MODULES.interpreters ? <S name="VendorInterpreters"><VendorInterpreters /></S> : <Navigate to="../arrivals" replace />} />
      <Route path="changes" element={<S name="VendorChanges"><VendorChanges /></S>} />
    </>
  );
  return (
    <PortalAppShell portal="vendor">
      <Routes>
        {/* Canonical (subdomain) */}
        <Route path="/login" element={<S name="VendorLogin"><VendorLogin /></S>} />
        <Route path="/" element={protectedLayout}>{childRoutes}</Route>
        {/* Prefixed alias (Lovable preview) */}
        <Route path="/vendor/login" element={<S name="VendorLogin"><VendorLogin /></S>} />
        <Route path="/vendor" element={protectedLayout}>{childRoutes}</Route>
        <Route path="*" element={<Navigate to={p("/login")} replace />} />
      </Routes>
    </PortalAppShell>
  );
};

export default VendorApp;
